/** Префикс API. В schema.d.ts его НЕТ: openapi.json объявляет servers.url = /api/v1,
 *  поэтому ключи путей выглядят как '/auth/login', и префикс приписывается здесь — в одном месте. */
export const API_PREFIX = '/api/v1';

export const DEFAULT_TIMEOUT_MS = 15_000;
